import es from './es.json';
import en from './en.json';

// Generic build: base translations only.
// Tenant-specific locale overrides are loaded at runtime from the BFF
// via GET /api/v1/tenant/locales/:locale.
const translations = {
  es: {
    translations: es,
  },
  en: {
    translations: en,
  },
};

export default translations;
